import script from "./CreateStreamCategoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateStreamCategoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateStreamCategoryDialog.vue?vue&type=style&index=0&id=f47840d6&lang=css"
import "./CreateStreamCategoryDialog.vue?vue&type=style&index=1&id=f47840d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f47840d6"]])

export default __exports__